<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="events" @selected="switchTab"></TabsWidget>
      <div class="tab-options"></div>
    </div>
    <div class="wrapper-body">
      <div class="left-panel">
        <div class="left-panel-header">
          <div class="left-panel-header-title">
            <span>EVENT SESSIONS</span>
          </div>
          <div class="left-panel-header-option"></div>
        </div>
        <div class="left-panel-body">
          <div v-if="event_sessions && event_sessions.length > 0">
            <div class="voting-session-item" v-for="(item, index) in event_sessions" :key="index"
              @click="selectEventSession(item)" :class="{
                active:
                  selected_event_session &&
                  selected_event_session.id == item.id,
              }">
              <div v-if="item.coverImage" class="voting-session-item-cover-image-panel">
                <img :src="$store.state.ASSETS_BASE_URL +
                  '/assets/uploaded/' +
                  item.coverImage
                  " />
              </div>
              <div class="voting-session-item-top-panel">
                <div class="voting-session-item-image">
                  <img :src="$store.state.ASSETS_BASE_URL +
                    '/assets/uploaded/' +
                    item.logoImage
                    " />
                </div>
                <div class="voting-session-item-title">
                  <span>{{ item.title }}</span>
                </div>
              </div>
              <div class="voting-session-item-body-panel" @click.stop>
                <b-select v-if="item.hasSubEvent == 1 && item.subEvents && item.subEvents.length > 0"
                  placeholder="Select sub event" @input="onSubEventSelected($event, item)">
                  <option v-for="subEvent in item.subEvents" :value="subEvent.id" :key="subEvent.id">
                    {{ getSubEventLabel(subEvent) }}
                  </option>
                </b-select>
              </div>
              <div class="voting-session-item-bottom-panel">
                <div class="voting-session-item-bottom-left">
                  <div class="voting-session-item-startdate">
                    <b-icon icon="calendar"></b-icon>
                    <span>Start Date:
                      {{
                        moment(item.startTime).format("MMMM Do YYYY, h:mm A")
                      }}</span>
                  </div>
                  <div class="voting-session-item-enddate">
                    <b-icon icon="calendar"></b-icon>
                    <span>End Date:
                      {{
                        moment(item.endTime).format("MMMM Do YYYY, h:mm A")
                      }}</span>
                  </div>
                </div>
                <div class="voting-session-item-bottom-left">
                  <b-tag v-if="item.status == 'public'" type="is-success">Public</b-tag>
                  <b-tag v-if="item.status == 'unlisted'" type="is-danger">Unlisted</b-tag>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rigth-panel active_session" v-if="selected_event_session">
        <div class="rigth-panel-header">
          <div class="rigth-panel-header-title">
            {{ selected_event_session.title }}
          </div>
          <b-button type="is-primary" outlined @click="newPrice()">NEW PRICE</b-button>
          <p @click="resetSession()">Close</p>
        </div>
        <div class="rigth-panel-body">
          <div v-if="!loading_pricing && pricing_data.length > 0" class="table-widget">
            <table>
              <tr>
                <th>Location</th>
                <th>Price</th>
                <th>Seat type</th>
                <th>Available Seat</th>
                <th>Bought Tickets</th>
                <th>Invitation Tickets</th>
                <th>Attendees</th>
                <th>Status</th>
                <th></th>
              </tr>
              <tr v-for="(item, index) in pricing_data" :key="index">
                <td>{{ item.item_index }} - {{ item.location }}</td>
                <td>{{ item.amount_range_enabled ? `${item.currency} ${item.min_amount} - ${item.max_amount}` : `${item.currency} ${item.amount}` }}</td>
                <td>{{ `${item.name}` }}({{ item.type == 'subevents' ? getSubEventLabel(item) : `Whole Event` }})</td>
                <td>{{ `${item.quantity - (item.boughtTickets + item.freeTickets)}/${item.quantity}` }}</td>
                <td>{{ `${item.boughtTickets}` }}</td>
                <td>{{ `${item.freeTickets}` }}</td>
                <td>{{ `${item.attendees}` }}</td>
                <td>
                  <b-tag v-if="item.status == 'pending'" type="is-warning">Pending</b-tag>
                  <b-tag v-if="item.status == 'published'" type="is-success">Published</b-tag>
                </td>
                <td>
                  <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                    <template #trigger>
                      <b-icon icon="dots-vertical"></b-icon>
                    </template>
                    <b-dropdown-item @click="updatePrice(item)" aria-role="listitem">Update</b-dropdown-item>
                    <b-dropdown-item @click="deletPrice(item.id, index)" aria-role="listitem"
                      v-if="item.boughtTickets < 1">Delete</b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
            </table>
          </div>

          <div v-if="loading_pricing" class="table-widget">
            <table>
              <tr>
                <th>Location</th>
                <th>Price</th>
                <th>Seat type</th>
                <th>Status</th>
                <th></th>
              </tr>
              <tr v-for="(item, index) in 15" :key="index">
                <td><b-skeleton width="90%"></b-skeleton></td>
                <td><b-skeleton width="90%"></b-skeleton></td>
                <td><b-skeleton width="90%"></b-skeleton></td>
                <td><b-skeleton width="90%"></b-skeleton></td>
                <td><b-skeleton width="90%"></b-skeleton></td>
              </tr>
            </table>
          </div>

          <widgetNotfound v-if="!loading_pricing && pricing_data.length == 0" title="No Pricing Found"
            subtitle="You have not created any pricing yet."></widgetNotfound>
        </div>
      </div>
      <div class="rigth-panel" v-else>
        <widgetNotfound title="No Event Selected" subtitle="Select event to its pricing"></widgetNotfound>
      </div>
    </div>

    <!-- Add Price Modal -->
    <addPricingModal v-if="show_pricing_modal && selected_event_session" @close="show_pricing_modal = false"
      :content="selected_item" :type="pricing_type" :ref_id="selected_event_session.id"
      :event_session="selected_event_session" @success="onAddPriceSuccess()">
    </addPricingModal>
  </div>
</template>

<script>
import TabsWidget from "./components/TabsWidget.vue";
import addPricingModal from "./components/add_pricing_modal.vue";
import { getSubEventLabel } from "@/helpers/subEvent.js";
export default {
  components: {
    TabsWidget,
    addPricingModal
  },
  sockets: {},
  data: () => ({
    pricing_type: "events",
    loading_pricing: false,
    show_pricing_modal: false,
    pricing_data: [],
    selected_item: null,
    event_sessions: [],
    loading_event_session: false,
    selected_event_session: null,
    selected_sub_event: 0,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getMyEventSessions();
  },
  methods: {
    getSubEventLabel,
    resetSession() {
      let vm = this;
      vm.selected_event_session = null;
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    getMyEventSessions() {
      let vm = this;
      vm.loading_event_session = true;
      vm.$store
        .dispatch("EVENTS_GET_ALL_EVENT")
        .then((response) => {
          vm.loading_event_session = false;
          vm.event_sessions = response.data;
        })
        .catch(({ response }) => {
          vm.loading_event_session = false;
        });
    },
    selectEventSession(item) {
      let vm = this;
      vm.selected_event_session = item;
      vm.selected_sub_event = 0;
      vm.getAllPrice();
    },
    onSubEventSelected(value, item) {
      let vm = this;
      vm.selected_event_session = item;
      vm.selected_sub_event = value;
      vm.getAllPrice();
    },
    getAllPrice() {
      let vm = this;
      if (!vm.selected_event_session) return;
      vm.loading_pricing = true;
      vm.$store
        .dispatch("PRICING_GET_PRICING", {
          type: vm.pricing_type,
          ref_id: vm.selected_event_session.id,
          subEventEnabled: vm.selected_sub_event > 0 && vm.selected_event_session.hasSubEvent == 1,
          selectedSubEvent: vm.selected_sub_event,
        })
        .then((response) => {
          vm.loading_pricing = false;
          vm.pricing_data = response.data.return.sort((a, b) =>
            a.item_index > b.item_index ? 1 : -1
          );
        })
        .catch(({ response }) => {
          vm.loading_pricing = false;
        });
    },
    newPrice() {
      let vm = this;
      vm.selected_item = null;
      vm.show_pricing_modal = true;
    },
    onAddPriceSuccess() {
      let vm = this;
      vm.show_pricing_modal = false;
      vm.getAllPrice();
    },
    deletPrice(id, index) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.$store
              .dispatch("PRICING_DELETE_PRICING", { id: id })
              .then((response) => {
                vm.pricing_data.splice(index, 1);
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: response.data.message,
                });
              });
          }
        },
      });
    },
    updatePrice(item) {
      let vm = this;
      vm.selected_item = item;
      vm.show_pricing_modal = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding-left: 6px;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        border-bottom: 3px solid transparent;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: grid;
    align-items: center;
    justify-content: center;
    grid-template-columns: 35% 65%;

    @media (max-width: 860px) {
      grid-template-columns: 40% 60%;
    }

    @media (max-width: 638px) {
      grid-template-columns: 100%;
    }

    .left-panel {
      height: 100%;
      // width: 400px;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      .left-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
        border-bottom: 1px solid #ddd;
        background: #fff;

        .left-panel-header-title {
          font-size: 14px;
          font-weight: 600;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          button {
            color: white;
            display: flex;
            padding: 7px 25px;
            border: none;
            justify-content: space-between;
            align-items: center;
            border-radius: 5px;
            background: #2A8CE5;
          }
        }

        .left-panel-header-option {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .h-spacer {
            margin-right: 10px;
          }
        }
      }

      .left-panel-body {
        overflow-y: auto;
        height: calc(100% - 60px);
        display: flex;
        flex-direction: column;

        .voting-session-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          border-bottom: 1px solid #ddd;
          cursor: pointer;

          &:hover {
            background: #fff;
          }

          &.active {
            background: #fff;
          }

          .voting-session-item-cover-image-panel {
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              height: 100%;
              width: 100%;
              object-fit: cover;
            }
          }

          .voting-session-item-top-panel {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            .voting-session-item-image {
              width: 50px;
              height: 50px;
              border-radius: 50%;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .voting-session-item-title {
              font-size: 14px;
              font-weight: 600;
              color: #333;
              width: calc(100% - 60px);
              padding: 0px 10px;
            }

            .voting-session-item-option {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 10px;
            }
          }

          .voting-session-item-body-panel {
            padding: 0px 10px;
          }

          .voting-session-item-bottom-panel {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            .voting-session-item-bottom-left {
              display: flex;
              flex-direction: column;

              .voting-session-item-startdate,
              .voting-session-item-enddate {
                font-size: 12px;
                color: #333;
                margin-bottom: 5px;
                display: flex;
                align-items: center;
              }
            }

            .voting-session-item-bottom-right {
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }

    .rigth-panel {
      // width: calc(100% - 400px);
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      @media (max-width: 638px) {
        position: absolute;
        background: white;
        z-index: 10;
        top: 0px;
        right: -800px;
        width: 85%;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);
        transition: .5s;
      }

      &.active_session {
        @media (max-width: 638px) {
          right: 0;
        }
      }

      .rigth-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
        border-bottom: 1px solid #ddd;

        .rigth-panel-header-title {
          -overflow: hidden;
          text-decoration: none;
          text-overflow: ellipsis;
          white-space: nowrap;
          background: white;
          width: 100%;
          margin-right: 15px;

          @media (max-width: 638px) {
            font-size: 14px;
          }

          @media (max-width: 439px) {
            font-size: 13px;
          }
        }
      }

      p {
        display: none;
        margin-left: 10px;
        color: red;
        font-weight: 700;
        cursor: pointer;

        @media (max-width: 638px) {
          display: flex;
        }
      }

      .rigth-panel-body {
        height: calc(100% - 60px);
        overflow-y: auto;
        display: flex;
        flex-direction: column;

        .table-widget {
          // height: calc(100% - 60px);
          overflow-y: auto;

          table {
            width: 100%;

            tr {
              th {
                white-space: nowrap;
              }

              td {
                white-space: nowrap;

                .tag-lists {
                  display: flex;
                  width: fit-content;
                  flex-shrink: 0;
                  min-width: 170px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>